/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost } from '../fn/members-secretariat-v-2/add-team-members-to-org-api-v-2-secretariat-members-org-id-team-post';
import { AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Params } from '../fn/members-secretariat-v-2/add-team-members-to-org-api-v-2-secretariat-members-org-id-team-post';
import { createMemberApiV2SecretariatMembersPost } from '../fn/members-secretariat-v-2/create-member-api-v-2-secretariat-members-post';
import { CreateMemberApiV2SecretariatMembersPost$Params } from '../fn/members-secretariat-v-2/create-member-api-v-2-secretariat-members-post';
import { getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet } from '../fn/members-secretariat-v-2/get-all-member-categories-api-v-2-secretariat-members-categories-all-get';
import { GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Params } from '../fn/members-secretariat-v-2/get-all-member-categories-api-v-2-secretariat-members-categories-all-get';
import { getAllMembersApiV2SecretariatMembersAllGet } from '../fn/members-secretariat-v-2/get-all-members-api-v-2-secretariat-members-all-get';
import { GetAllMembersApiV2SecretariatMembersAllGet$Params } from '../fn/members-secretariat-v-2/get-all-members-api-v-2-secretariat-members-all-get';
import { getAllSecretariatMembersApiV2SecretariatMembersGet } from '../fn/members-secretariat-v-2/get-all-secretariat-members-api-v-2-secretariat-members-get';
import { GetAllSecretariatMembersApiV2SecretariatMembersGet$Params } from '../fn/members-secretariat-v-2/get-all-secretariat-members-api-v-2-secretariat-members-get';
import { getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet } from '../fn/members-secretariat-v-2/get-secretariat-member-submissions-cycles-api-v-2-secretariat-members-org-id-submissions-cycles-get';
import { GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Params } from '../fn/members-secretariat-v-2/get-secretariat-member-submissions-cycles-api-v-2-secretariat-members-org-id-submissions-cycles-get';
import { inviteSecretariatMembersApiV2SecretariatMembersMemberPost } from '../fn/members-secretariat-v-2/invite-secretariat-members-api-v-2-secretariat-members-member-post';
import { InviteSecretariatMembersApiV2SecretariatMembersMemberPost$Params } from '../fn/members-secretariat-v-2/invite-secretariat-members-api-v-2-secretariat-members-member-post';
import { MemberCategories } from '../models/member-categories';
import { MembersSendEmailResponseSchema } from '../models/members-send-email-response-schema';
import { MembersWithoutSupplierData } from '../models/members-without-supplier-data';
import { MembersWithTeamValidation } from '../models/members-with-team-validation';
import { memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch } from '../fn/members-secretariat-v-2/member-update-status-api-v-2-secretariat-members-org-id-status-patch';
import { MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Params } from '../fn/members-secretariat-v-2/member-update-status-api-v-2-secretariat-members-org-id-status-patch';
import { PageMembersWithTeamValidation } from '../models/page-members-with-team-validation';
import { PageSecretariatMembersListAll } from '../models/page-secretariat-members-list-all';
import { removeMemberApiV2SecretariatMembersOrgIdMembershipDelete } from '../fn/members-secretariat-v-2/remove-member-api-v-2-secretariat-members-org-id-membership-delete';
import { RemoveMemberApiV2SecretariatMembersOrgIdMembershipDelete$Params } from '../fn/members-secretariat-v-2/remove-member-api-v-2-secretariat-members-org-id-membership-delete';
import { removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete } from '../fn/members-secretariat-v-2/remove-team-members-in-org-api-v-2-secretariat-members-org-id-teams-delete';
import { RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Params } from '../fn/members-secretariat-v-2/remove-team-members-in-org-api-v-2-secretariat-members-org-id-teams-delete';
import { SecretariatInviteMembers } from '../models/secretariat-invite-members';
import { SecretariatMembersSubmissionsCycles } from '../models/secretariat-members-submissions-cycles';
import { sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost } from '../fn/members-secretariat-v-2/send-secretariat-member-emails-api-v-2-secretariat-members-members-emails-post';
import { SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Params } from '../fn/members-secretariat-v-2/send-secretariat-member-emails-api-v-2-secretariat-members-members-emails-post';
import { Team } from '../models/team';
import { updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch } from '../fn/members-secretariat-v-2/update-member-organization-api-v-2-secretariat-members-org-id-profile-patch';
import { UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Params } from '../fn/members-secretariat-v-2/update-member-organization-api-v-2-secretariat-members-org-id-profile-patch';

@Injectable({ providedIn: 'root' })
export class MembersSecretariatV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSecretariatMembersApiV2SecretariatMembersGet()` */
  static readonly GetAllSecretariatMembersApiV2SecretariatMembersGetPath = '/api/v2/secretariat/members';

  /**
   * Get All Secretariat Members.
   *
   * Retrieve a paginated list of secretariat members with optional data censoring.
   *
   * This endpoint returns a paginated list of secretariat members associated with
   * the specified secretariat identifier. An optional query parameter allows for filtering
   * the results by member name. Sensitive data like emails and names can be censored by
   * setting censor_data=true. Access is restricted to authenticated users who are members
   * of the organization, and the organization must be recognized as a secretariat.
   *
   * Args:
   *     tenant (str): Contains tenant (secretariat) ID
   *     org (Any): Organization details used for permission validation.
   *     name (str, optional): Filter string to retrieve members whose names match.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Raises:
   *     HTTPException: 401 if the user is not a member of the organization.
   *     HTTPException: 401 if the organization is not designated as a secretariat.
   *
   * Returns:
   *     Page[schemas.SecretariatMembersListAll]: Paginated list of secretariat members with their primary contact persons.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSecretariatMembersApiV2SecretariatMembersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSecretariatMembersApiV2SecretariatMembersGet$Response(params: GetAllSecretariatMembersApiV2SecretariatMembersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageSecretariatMembersListAll>> {
    return getAllSecretariatMembersApiV2SecretariatMembersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Secretariat Members.
   *
   * Retrieve a paginated list of secretariat members with optional data censoring.
   *
   * This endpoint returns a paginated list of secretariat members associated with
   * the specified secretariat identifier. An optional query parameter allows for filtering
   * the results by member name. Sensitive data like emails and names can be censored by
   * setting censor_data=true. Access is restricted to authenticated users who are members
   * of the organization, and the organization must be recognized as a secretariat.
   *
   * Args:
   *     tenant (str): Contains tenant (secretariat) ID
   *     org (Any): Organization details used for permission validation.
   *     name (str, optional): Filter string to retrieve members whose names match.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Raises:
   *     HTTPException: 401 if the user is not a member of the organization.
   *     HTTPException: 401 if the organization is not designated as a secretariat.
   *
   * Returns:
   *     Page[schemas.SecretariatMembersListAll]: Paginated list of secretariat members with their primary contact persons.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSecretariatMembersApiV2SecretariatMembersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSecretariatMembersApiV2SecretariatMembersGet(params: GetAllSecretariatMembersApiV2SecretariatMembersGet$Params, context?: HttpContext): Observable<PageSecretariatMembersListAll> {
    return this.getAllSecretariatMembersApiV2SecretariatMembersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageSecretariatMembersListAll>): PageSecretariatMembersListAll => r.body)
    );
  }

  /** Path part for operation `createMemberApiV2SecretariatMembersPost()` */
  static readonly CreateMemberApiV2SecretariatMembersPostPath = '/api/v2/secretariat/members';

  /**
   * Create Member.
   *
   * Create a new secretariat member record.
   *
   * This endpoint creates a new member document for a secretariat. It validates that the organization is a secretariat,
   * processes any supplier data provided by ensuring the supplier exists, and records the creator's email.
   * If any supplier is invalid, a 400 error is raised.
   *
   * Args:
   *     member_in (schemas.MembersCreateIn): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *     HTTPException: 400 if a provided supplier is invalid.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The newly created member record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createMemberApiV2SecretariatMembersPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberApiV2SecretariatMembersPost$Response(params: CreateMemberApiV2SecretariatMembersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return createMemberApiV2SecretariatMembersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Member.
   *
   * Create a new secretariat member record.
   *
   * This endpoint creates a new member document for a secretariat. It validates that the organization is a secretariat,
   * processes any supplier data provided by ensuring the supplier exists, and records the creator's email.
   * If any supplier is invalid, a 400 error is raised.
   *
   * Args:
   *     member_in (schemas.MembersCreateIn): Input schema containing member details.
   *     auth_token (Any): Authentication token used for user validation.
   *     org (Any): Organization details used for permission verification.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *     HTTPException: 400 if a provided supplier is invalid.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The newly created member record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createMemberApiV2SecretariatMembersPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createMemberApiV2SecretariatMembersPost(params: CreateMemberApiV2SecretariatMembersPost$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.createMemberApiV2SecretariatMembersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet()` */
  static readonly GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGetPath = '/api/v2/secretariat/members/{orgId}/submissions-cycles';

  /**
   * Get Secretariat Member Submissions Cycles.
   *
   * Retrieve submission cycles for a secretariat member.
   *
   * This endpoint fetches all submission cycles linked to a particular secretariat member,
   * identified by the recipient organization ID. The process is available only to users
   * who belong to the organization and when the organization is confirmed as a secretariat.
   *
   * Args:
   *     tenant (str): Contains tenant (secretariat) ID
   *     org (Any): Organization details for validating access permissions.
   *     org_id (str): Organization ID of the secretariat member whose submission cycles are requested.
   *
   * Raises:
   *     HTTPException: 401 if the requesting user is not part of the organization.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * Returns:
   *     schemas.SecretariatMembersSubmissionsCycles: A dictionary with the recipient org ID and a list of submission cycle details.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Response(params: GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretariatMembersSubmissionsCycles>> {
    return getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Secretariat Member Submissions Cycles.
   *
   * Retrieve submission cycles for a secretariat member.
   *
   * This endpoint fetches all submission cycles linked to a particular secretariat member,
   * identified by the recipient organization ID. The process is available only to users
   * who belong to the organization and when the organization is confirmed as a secretariat.
   *
   * Args:
   *     tenant (str): Contains tenant (secretariat) ID
   *     org (Any): Organization details for validating access permissions.
   *     org_id (str): Organization ID of the secretariat member whose submission cycles are requested.
   *
   * Raises:
   *     HTTPException: 401 if the requesting user is not part of the organization.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * Returns:
   *     schemas.SecretariatMembersSubmissionsCycles: A dictionary with the recipient org ID and a list of submission cycle details.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet(params: GetSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Params, context?: HttpContext): Observable<SecretariatMembersSubmissionsCycles> {
    return this.getSecretariatMemberSubmissionsCyclesApiV2SecretariatMembersOrgIdSubmissionsCyclesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecretariatMembersSubmissionsCycles>): SecretariatMembersSubmissionsCycles => r.body)
    );
  }

  /** Path part for operation `getAllMembersApiV2SecretariatMembersAllGet()` */
  static readonly GetAllMembersApiV2SecretariatMembersAllGetPath = '/api/v2/secretariat/members/all';

  /**
   * Get All Members.
   *
   * Retrieve all member records with optional name filtering and data censoring.
   *
   * This endpoint retrieves the complete list of member records with detailed team validation.
   * An optional name filter can be applied to narrow down the search results.
   * Sensitive data like emails and names can be censored by setting censor_data=true.
   * Only organizations designated as secretariats can access this endpoint.
   *
   * Args:
   *     org (Any): Organization details for permission checking.
   *     name (str, optional): Filter parameter to search for members by name.
   *     exclude_deleted (bool, optional): Whether to exclude members with 'deleted' status. Defaults to True.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *
   * Returns:
   *     Page[schemas.MembersWithTeamValidation]: A paginated list of member records with their associated team data.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMembersApiV2SecretariatMembersAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMembersApiV2SecretariatMembersAllGet$Response(params: GetAllMembersApiV2SecretariatMembersAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageMembersWithTeamValidation>> {
    return getAllMembersApiV2SecretariatMembersAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Members.
   *
   * Retrieve all member records with optional name filtering and data censoring.
   *
   * This endpoint retrieves the complete list of member records with detailed team validation.
   * An optional name filter can be applied to narrow down the search results.
   * Sensitive data like emails and names can be censored by setting censor_data=true.
   * Only organizations designated as secretariats can access this endpoint.
   *
   * Args:
   *     org (Any): Organization details for permission checking.
   *     name (str, optional): Filter parameter to search for members by name.
   *     exclude_deleted (bool, optional): Whether to exclude members with 'deleted' status. Defaults to True.
   *     censor_data (bool, optional): Whether to censor sensitive data like emails and names. Defaults to False.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *
   * Returns:
   *     Page[schemas.MembersWithTeamValidation]: A paginated list of member records with their associated team data.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMembersApiV2SecretariatMembersAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMembersApiV2SecretariatMembersAllGet(params: GetAllMembersApiV2SecretariatMembersAllGet$Params, context?: HttpContext): Observable<PageMembersWithTeamValidation> {
    return this.getAllMembersApiV2SecretariatMembersAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageMembersWithTeamValidation>): PageMembersWithTeamValidation => r.body)
    );
  }

  /** Path part for operation `memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch()` */
  static readonly MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatchPath = '/api/v2/secretariat/members/{orgId}/status';

  /**
   * Member Update Status.
   *
   * Update a secretariat member's status.
   *
   * Change the status of a member record to either active, suspended, or deleted.
   * The appropriate timestamp is recorded for the action taken. This endpoint is accessible
   * only if the organization is a secretariat.
   *
   * Args:
   *     org (Any): Organization details for validating permissions.
   *     org_id (str): Organization ID of the member to update.
   *     action (Literal["suspend", "delete", "activate"]): The status action to perform.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *     HTTPException: 400 if the member does not exist.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Response(params: MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Member Update Status.
   *
   * Update a secretariat member's status.
   *
   * Change the status of a member record to either active, suspended, or deleted.
   * The appropriate timestamp is recorded for the action taken. This endpoint is accessible
   * only if the organization is a secretariat.
   *
   * Args:
   *     org (Any): Organization details for validating permissions.
   *     org_id (str): Organization ID of the member to update.
   *     action (Literal["suspend", "delete", "activate"]): The status action to perform.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not a secretariat.
   *     HTTPException: 400 if the member does not exist.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch(params: MemberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.memberUpdateStatusApiV2SecretariatMembersOrgIdStatusPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `inviteSecretariatMembersApiV2SecretariatMembersMemberPost()` */
  static readonly InviteSecretariatMembersApiV2SecretariatMembersMemberPostPath = '/api/v2/secretariat/members/member';

  /**
   * Invite Secretariat Members.
   *
   * Invite and create new secretariat member records.
   *
   * This endpoint invites new secretariat members by creating their records.
   * It sets default attributes (such as active status and primary team membership) for each new member.
   * Only authenticated users who are part of the organization's team and when the organization is a secretariat
   * can perform this action. Use the separate `/member/send-emails` endpoint to send welcome emails.
   *
   * Args:
   *     member_in (list[schemas.MembersSecretariatCreateFromEmailInvite]): List of input data for the new members.
   *     auth_token (Any): Authentication token for validating the requesting user.
   *     tenant (str): The tenant/secretariat identifier.
   *     org (Any): Organization details for permission verification.
   *
   * Raises:
   *     HTTPException: 401 if the user is not a member of the organization.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * Returns:
   *     list[schemas.MembersWithoutSupplierData]: List of newly created secretariat member records.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inviteSecretariatMembersApiV2SecretariatMembersMemberPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSecretariatMembersApiV2SecretariatMembersMemberPost$Response(params: InviteSecretariatMembersApiV2SecretariatMembersMemberPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SecretariatInviteMembers>> {
    return inviteSecretariatMembersApiV2SecretariatMembersMemberPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Invite Secretariat Members.
   *
   * Invite and create new secretariat member records.
   *
   * This endpoint invites new secretariat members by creating their records.
   * It sets default attributes (such as active status and primary team membership) for each new member.
   * Only authenticated users who are part of the organization's team and when the organization is a secretariat
   * can perform this action. Use the separate `/member/send-emails` endpoint to send welcome emails.
   *
   * Args:
   *     member_in (list[schemas.MembersSecretariatCreateFromEmailInvite]): List of input data for the new members.
   *     auth_token (Any): Authentication token for validating the requesting user.
   *     tenant (str): The tenant/secretariat identifier.
   *     org (Any): Organization details for permission verification.
   *
   * Raises:
   *     HTTPException: 401 if the user is not a member of the organization.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * Returns:
   *     list[schemas.MembersWithoutSupplierData]: List of newly created secretariat member records.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inviteSecretariatMembersApiV2SecretariatMembersMemberPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inviteSecretariatMembersApiV2SecretariatMembersMemberPost(params: InviteSecretariatMembersApiV2SecretariatMembersMemberPost$Params, context?: HttpContext): Observable<SecretariatInviteMembers> {
    return this.inviteSecretariatMembersApiV2SecretariatMembersMemberPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<SecretariatInviteMembers>): SecretariatInviteMembers => r.body)
    );
  }

  /** Path part for operation `sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost()` */
  static readonly SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPostPath = '/api/v2/secretariat/members/members/emails';

  /**
   * Send Secretariat Member Emails.
   *
   * Send welcome emails to newly-added secretariat members.
   *
   * This endpoint sends welcome emails to secretariat members asynchronously via background tasks.
   * It accepts a list of company names and email addresses to send welcome emails to each.
   *
   * Args:
   *     member_input (list[schemas.MembersSendEmailSchema]): List containing company names and email addresses.
   *     tenant (str): The tenant/secretariat identifier.
   *     org (Any): Organization details for permission validation.
   *     background_tasks (BackgroundTasks): Background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersSendEmailResponseSchema: Response with confirmation details.
   *
   * Raises:
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Response(params: SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersSendEmailResponseSchema>> {
    return sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Send Secretariat Member Emails.
   *
   * Send welcome emails to newly-added secretariat members.
   *
   * This endpoint sends welcome emails to secretariat members asynchronously via background tasks.
   * It accepts a list of company names and email addresses to send welcome emails to each.
   *
   * Args:
   *     member_input (list[schemas.MembersSendEmailSchema]): List containing company names and email addresses.
   *     tenant (str): The tenant/secretariat identifier.
   *     org (Any): Organization details for permission validation.
   *     background_tasks (BackgroundTasks): Background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersSendEmailResponseSchema: Response with confirmation details.
   *
   * Raises:
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost(params: SendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Params, context?: HttpContext): Observable<MembersSendEmailResponseSchema> {
    return this.sendSecretariatMemberEmailsApiV2SecretariatMembersMembersEmailsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersSendEmailResponseSchema>): MembersSendEmailResponseSchema => r.body)
    );
  }

  /** Path part for operation `removeMemberApiV2SecretariatMembersOrgIdMembershipDelete()` */
  static readonly RemoveMemberApiV2SecretariatMembersOrgIdMembershipDeletePath = '/api/v2/secretariat/members/{orgId}/membership';

  /**
   * Remove Member.
   *
   * Remove secretariat membership from a member.
   *
   * This endpoint removes the secretariat membership flag from a member record, effectively revoking
   * the secretariat privileges. It first validates that the requesting user is part of the organization's team
   * and that the organization is indeed a secretariat. Only the 'remove' action is supported.
   *
   * Args:
   *     org (Any): Organization details for validating the request.
   *     secretariat_id (str): Identifier for the secretariat.
   *     org_id (str): Organization ID of the member to update.
   *     action (Literal["remove"]): The action to perform, currently only supports "remove".
   *
   * Raises:
   *     HTTPException: 401 if the organization is not a secretariat.
   *     HTTPException: 400 if the member or organization does not exist.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record with secretariat membership removed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeMemberApiV2SecretariatMembersOrgIdMembershipDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMemberApiV2SecretariatMembersOrgIdMembershipDelete$Response(params: RemoveMemberApiV2SecretariatMembersOrgIdMembershipDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
    return removeMemberApiV2SecretariatMembersOrgIdMembershipDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove Member.
   *
   * Remove secretariat membership from a member.
   *
   * This endpoint removes the secretariat membership flag from a member record, effectively revoking
   * the secretariat privileges. It first validates that the requesting user is part of the organization's team
   * and that the organization is indeed a secretariat. Only the 'remove' action is supported.
   *
   * Args:
   *     org (Any): Organization details for validating the request.
   *     secretariat_id (str): Identifier for the secretariat.
   *     org_id (str): Organization ID of the member to update.
   *     action (Literal["remove"]): The action to perform, currently only supports "remove".
   *
   * Raises:
   *     HTTPException: 401 if the organization is not a secretariat.
   *     HTTPException: 400 if the member or organization does not exist.
   *
   * Returns:
   *     schemas.MembersWithoutSupplierData: The updated member record with secretariat membership removed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeMemberApiV2SecretariatMembersOrgIdMembershipDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeMemberApiV2SecretariatMembersOrgIdMembershipDelete(params: RemoveMemberApiV2SecretariatMembersOrgIdMembershipDelete$Params, context?: HttpContext): Observable<MembersWithoutSupplierData> {
    return this.removeMemberApiV2SecretariatMembersOrgIdMembershipDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithoutSupplierData>): MembersWithoutSupplierData => r.body)
    );
  }

  /** Path part for operation `addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost()` */
  static readonly AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPostPath = '/api/v2/secretariat/members/{orgId}/team';

  /**
   * Add Team Members To Org.
   *
   * Add new team members to an organization. Can only be used by Secretariat users
   *
   * This endpoint allows adding one or more team members to the specified organization.
   * It validates that each new team member's email is not already present in the organization's team,
   * updates the team accordingly, and sends an invitation email asynchronously.
   *
   * Args:
   *     team_in (list[schemas.Team]): A list of team member data to be added.
   *     org_id (Any): Organization details to which team members are being added.
   *     org: Organization ID to be used for determining if a user is a Secretariat user
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a team member's email already exists.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Response(params: AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
    return addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add Team Members To Org.
   *
   * Add new team members to an organization. Can only be used by Secretariat users
   *
   * This endpoint allows adding one or more team members to the specified organization.
   * It validates that each new team member's email is not already present in the organization's team,
   * updates the team accordingly, and sends an invitation email asynchronously.
   *
   * Args:
   *     team_in (list[schemas.Team]): A list of team member data to be added.
   *     org_id (Any): Organization details to which team members are being added.
   *     org: Organization ID to be used for determining if a user is a Secretariat user
   *     background_tasks (BackgroundTasks): A background task handler for sending emails.
   *
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if a team member's email already exists.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost(params: AddTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Params, context?: HttpContext): Observable<Array<Team>> {
    return this.addTeamMembersToOrgApiV2SecretariatMembersOrgIdTeamPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Team>>): Array<Team> => r.body)
    );
  }

  /** Path part for operation `removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete()` */
  static readonly RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDeletePath = '/api/v2/secretariat/members/{orgId}/teams';

  /**
   * Remove Team Members In Org.
   *
   * Remove specified team members from an organization. Can only be used by secretariat users.
   *
   * This endpoint removes team members (by email) from the organization's team list.
   * It updates the team list by filtering out the specified members.
   *
   * Args:
   *     org_id (Any): Organization ID from which team members are to be removed.
   *     team_in (schemas.TeamMembersToRemove): Data specifying the list of team member emails to remove.
   *     org: Organization ID to be used for determining if a user is a Secretariat user
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching team members are found.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Response(params: RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
    return removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove Team Members In Org.
   *
   * Remove specified team members from an organization. Can only be used by secretariat users.
   *
   * This endpoint removes team members (by email) from the organization's team list.
   * It updates the team list by filtering out the specified members.
   *
   * Args:
   *     org_id (Any): Organization ID from which team members are to be removed.
   *     team_in (schemas.TeamMembersToRemove): Data specifying the list of team member emails to remove.
   *     org: Organization ID to be used for determining if a user is a Secretariat user
   * Returns:
   *     list[schemas.Team]: The updated list of team members.
   *
   * Raises:
   *     HTTPException: If the authenticated user is not a member of the organization or if no matching team members are found.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete(params: RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Params, context?: HttpContext): Observable<Array<Team>> {
    return this.removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Team>>): Array<Team> => r.body)
    );
  }

  /** Path part for operation `getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet()` */
  static readonly GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGetPath = '/api/v2/secretariat/members/categories/all';

  /**
   * Get All Member Categories.
   *
   * Retrieve all member categories
   * Args:
   *     org (Any): Organization details for permission checking.
   *     name (str, optional): Filter parameter to search for members by name.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     list[schemas.MemberCategories]: A list of all Member Categories records
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Response(params: GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MemberCategories>>> {
    return getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get All Member Categories.
   *
   * Retrieve all member categories
   * Args:
   *     org (Any): Organization details for permission checking.
   *     name (str, optional): Filter parameter to search for members by name.
   *
   * Raises:
   *     HTTPException: 400 if the organization is not an admin internal user.
   *
   * Returns:
   *     list[schemas.MemberCategories]: A list of all Member Categories records
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet(params: GetAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Params, context?: HttpContext): Observable<Array<MemberCategories>> {
    return this.getAllMemberCategoriesApiV2SecretariatMembersCategoriesAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MemberCategories>>): Array<MemberCategories> => r.body)
    );
  }

  /** Path part for operation `updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch()` */
  static readonly UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatchPath = '/api/v2/secretariat/members/{orgId}/profile';

  /**
   * Update Member Organization.
   *
   * Update a member organization's details and primary contact.
   *
   * This endpoint allows secretariat users to update member organization information,
   * including name, category, and primary contact email. When a new contact email is provided,
   * it finds and updates the existing primary contact's email, or creates a new primary contact
   * if none exists. Ensures only one primary contact exists per organization.
   *
   * Args:
   *     org_id (str): The organization ID of the member to update.
   *     org (Any): Secretariat organization details for permission validation.
   *     tenant (str): The tenant/secretariat identifier.
   *     member_in (schemas.MembersUpdateBySecretariat): Update data including optional
   *         name, category, and contact_email fields.
   *     background_tasks (BackgroundTasks): Background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersWithTeamValidation: The updated member organization record.
   *
   * Raises:
   *     HTTPException: 400 if the member/organization does not exist.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Response(params: UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithTeamValidation>> {
    return updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Member Organization.
   *
   * Update a member organization's details and primary contact.
   *
   * This endpoint allows secretariat users to update member organization information,
   * including name, category, and primary contact email. When a new contact email is provided,
   * it finds and updates the existing primary contact's email, or creates a new primary contact
   * if none exists. Ensures only one primary contact exists per organization.
   *
   * Args:
   *     org_id (str): The organization ID of the member to update.
   *     org (Any): Secretariat organization details for permission validation.
   *     tenant (str): The tenant/secretariat identifier.
   *     member_in (schemas.MembersUpdateBySecretariat): Update data including optional
   *         name, category, and contact_email fields.
   *     background_tasks (BackgroundTasks): Background task handler for sending emails.
   *
   * Returns:
   *     schemas.MembersWithTeamValidation: The updated member organization record.
   *
   * Raises:
   *     HTTPException: 400 if the member/organization does not exist.
   *     HTTPException: 401 if the organization is not a secretariat.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch(params: UpdateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Params, context?: HttpContext): Observable<MembersWithTeamValidation> {
    return this.updateMemberOrganizationApiV2SecretariatMembersOrgIdProfilePatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<MembersWithTeamValidation>): MembersWithTeamValidation => r.body)
    );
  }

}
